import { type ComponentProps, Fragment, memo, type ReactNode } from 'react';

import { type BaseCustomField } from '@air/api/types';
import { cn } from '@air/utils-tailwind';

export type ContentCollectionCustomFieldsListProps = Pick<ComponentProps<'div'>, 'className'> & {
  renderCustomField: (props: { customField: BaseCustomField }) => ReactNode;
  customFields: BaseCustomField[];
};

export const ContentCollectionCustomFieldsList = memo(
  ({ className, renderCustomField, customFields }: ContentCollectionCustomFieldsListProps) => {
    return (
      <div className={cn('flex flex-col gap-2', className)} data-testid="CONTENT_COLLECTION_CUSTOM_FIELDS_LIST">
        {customFields.map((customField) => {
          return <Fragment key={customField.id}>{renderCustomField({ customField })}</Fragment>;
        })}
      </div>
    );
  },
);

ContentCollectionCustomFieldsList.displayName = 'ContentCollectionCustomFieldsList';
